<template>
  <div class="sessionsList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_teamsList')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 团队名称input -->
        <el-form-item :label="$t('lang.lab_teamName')">
          <input style="display: none"/>
          <el-input v-model="teamName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_teamName')"></el-input>
        </el-form-item>
        <!-- 场馆input -->
        <!-- <el-form-item :label="$t('lang.lab_venue')"> -->
          <!-- <input style="display: none"/> -->
          <!-- <el-input v-model="venue" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_venue')"></el-input> -->
        <!-- </el-form-item> -->
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 团队名称-->
        <el-table-column prop="teamName" :label="$t('lang.lab_teamName')" :sortable="'custom'"></el-table-column>
        <!-- 队长电话 -->
        <el-table-column prop="phone" :label="$t('lang.lab_leaderPhone')" :sortable="'custom'"></el-table-column>
        <!-- 人数 -->
        <el-table-column prop="number" :label="$t('lang.lab_numberOfPeoplee')" :sortable="'custom'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
            <el-button @click="onDetail(scope.row)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="160px" label-suffix=":">
        <!-- 团队名称 -->
        <el-form-item prop="teamName" :label="$t('lang.lab_teamName')">
          <input style="display: none"/>
          <el-input v-model="form.teamName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_teamName')" maxlength="10" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 队长电话 -->
        <el-form-item prop="phone" :label="$t('lang.lab_leaderPhone')">
          <input style="display: none"/>
          <el-input v-model="form.phone" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_leaderPhone')" maxlength="11" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 人数 -->
        <el-form-item prop="number" :label="$t('lang.lab_numberOfPeoplee')" v-if="isCase === 2">
          <input style="display: none"/>
          <el-input v-model="form.number" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_numberOfPeoplee')" maxlength="50" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="isCase !== 2">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:sessionsList
 *@Description:团队管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-15
 */
export default {
  name: '',
  components: {},
  data() {
    // 排序
    var orderCheck = (rule, value, callback) => {
      var str = rule.field.toString()
      // str = str.replace('competeItemList.', '')
      str = str.replace('.itemOrder', '')
      let a = Number(str)
      console.log('str', str, this.form.competeItemList[a], this.form.competeItemList[a].isSelected)
      // if (this.form.competeItemList[a].isSelected === false) {
      //   callback()
      // }
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_order')))
      } else if (value < 1) {
        callback(new Error(this.$i18n.t('lang.warning_orderLow')))
      } else {
        callback()
      }
    }
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isCase: 0, // 当前状态：0新增 1编辑 2查看
      /* 确定按钮可点击 */
      isDisabled: true, // 确定按钮置灰
      /* 团队管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      checkAll: false, // 表示 checkbox 的全选状态
      isIndeterminate: true, // 表示 checkbox 的不确定状态
      tableData: [], // 团队管理列表数据
      teamName: '', // 团队名称
      /* 记忆筛选项值 */
      teamName_bak: '', // 备份-团队
      /* 团队管理(新建编辑查看)变量 */
      rules: {
        teamName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_teamName'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_leaderPhone'), trigger: 'blur' }],
      },
      cRules: {
        itemOrder: [{ required: true, validator: orderCheck, trigger: 'blur' }],
      },
      form: {
        teamId: '',
        competeId: '',
        teamName: '',
        phone: '',
        number: '',
      }, // 详细数据
      multipleSelectionC: []
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取团队管理列表数据
    getData() {
      this.$get(`/team/list?competeId=${this.competeId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
  
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.sessions_bak = this.teamName
      } else { 
        // 筛选项正确显示
        this.teamName = this.teamName_bak
      }
      this.$get(`/team/list?competeId=${this.competeId}&sortName=${this.sortName}&teamName=${this.teamName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.teamName = ''
      this.teamName_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 新增
    onAdd() {
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.isCase = 0
      this.checkAll = false
      this.isIndeterminate = false
      this.form.teamId = ''
      this.form.competeId = this.competeId
      this.form.teamName = ''
      this.form.phone = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/team/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.isCase = 1
      this.form.teamId = data.id
      this.form.competeId = ''
      this.form.teamName = data.teamName
      this.form.phone = data.phone
      this.isShow = true
    },
    // 查看
    onDetail(data) {
      this.isTitle = this.$i18n.t('lang.btn_detail')
      this.isCase = 2
      this.form.teamId = data.id
      this.form.competeId = this.competeId
      this.form.teamName = data.teamName
      this.form.phone = data.phone
      this.form.number = data.number
      this.isShow = true
    },
    // 保存
    toSave(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
              let params = this.form
              this.$postJson('/team/addRoUpdate', params).then(
                res => {
                    if (res && res.code === 200) {
                      that.$message({
                        type: 'success',
                        message: that.$i18n.t('lang.lab_modifySuccess')
                      })
                      that.handleDialogClosed()
                      // 更新列表
                      this.onSearch(true, false)
                    } else {
                      that.$message.error(res.message)
                    }
                  },
                  error => {
                    that.$message.error(error)
                  }
                )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      this.isShow = false
      this.checkAll = false
      this.isIndeterminate = false
      this.$refs.form.clearValidate()
      this.form.teamId = ''
      this.form.competeId = ''
      this.form.teamName = ''
      this.form.phone = ''
      this.form.number = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      this.isShow = false
      this.checkAll = false
      this.isIndeterminate = false
      this.$refs.form.clearValidate()
      this.form.teamId = ''
      this.form.competeId = ''
      this.form.teamName = ''
      this.form.phone = ''
      // this.form.number = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },

    // 详情-赛事项目半选
    handleCheckedCompeteChange(value) {
      if (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.competeIds.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.competeIds.length
      }
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.id
    if (this.competeId !== '') {
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.sessionsList{
  .margin-l10 {
    margin-left: 10px;
  }
  .table-position{
    .el-table__header {
      width: 100% !important;
    }
    .el-table__empty-block {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
    }
  }
}
</style>
